import { Button, Paper, Stack, Typography } from "@mui/material";

function RetreatDayCard({
  title,
  videos,
  loading,
  onAdd,
  renderVideoSkeletons,
  renderUnifiedList,
  emptyText,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: "1px solid #d0e2ff",
        background: "#f0f6ff",
        mb: 3,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Typography variant="h6">{title}</Typography>
        <Button variant="contained" onClick={onAdd}>
          Add Video
        </Button>
      </Stack>
      {loading ? (
        renderVideoSkeletons(3)
      ) : videos.length === 0 ? (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            border: "1px dashed #cbd5e1",
            background: "#fff",
            borderRadius: 2,
            color: "#607d8b",
            textAlign: "center",
          }}
        >
          {emptyText}
        </Paper>
      ) : (
        renderUnifiedList(videos, "video")
      )}
    </Paper>
  );
}

export default function RetreatDayVideosSection({
  day1,
  day2,
  day3,
  onAddDay1,
  onAddDay2,
  onAddDay3,
  renderVideoSkeletons,
  renderUnifiedList,
}) {
  return (
    <>
      <RetreatDayCard
        title="Meditation Retreat Day 1"
        videos={day1.items}
        loading={day1.loading}
        onAdd={onAddDay1}
        renderVideoSkeletons={renderVideoSkeletons}
        renderUnifiedList={renderUnifiedList}
        emptyText="No Day 1 videos uploaded yet."
      />
      <RetreatDayCard
        title="Meditation Retreat Day 2"
        videos={day2.items}
        loading={day2.loading}
        onAdd={onAddDay2}
        renderVideoSkeletons={renderVideoSkeletons}
        renderUnifiedList={renderUnifiedList}
        emptyText="No Day 2 videos uploaded yet."
      />
      <RetreatDayCard
        title="Meditation Retreat Day 3"
        videos={day3.items}
        loading={day3.loading}
        onAdd={onAddDay3}
        renderVideoSkeletons={renderVideoSkeletons}
        renderUnifiedList={renderUnifiedList}
        emptyText="No Day 3 videos uploaded yet."
      />
    </>
  );
}
